import React from 'react';

const UserListCard = ({ title, statusIcon, users }) => {
    return (
        <div className="user-list-card">
            <div className="card-header">
                <div className="card-title">
                    <span className="status-icon">{statusIcon}</span>
                    {title}
                </div>
                <div className="user-count">{users.length}</div>
            </div>
            <div className="user-list">
                {users.map(user => (
                    <div key={user.id} className="user-item">
                        <img src={user.image} alt={user.name} className="user-avatar" />
                        <div className="user-details">
                            <p className="user-name">{user.name}</p>
                            <p className="user-meta">{user.meta}</p>
                        </div>
                        {/* Assuming comment button is present based on image */}
                        <button className="comment-btn">Commentaire</button>
                    </div>
                ))}
                {users.length === 0 && <div className="no-data">Aucun utilisateur dans cette liste.</div>}
            </div>
        </div>
    );
};

export default UserListCard; 